<template>
  <div class="world-cup-container">
    <!-- 시작 화면 -->
    <div v-if="start" class="world-cup-start">
      <img src="../assets/world-cup/worldcup_main.png" alt="" />
      <h2>취향으로 알아보는 심리 테스트</h2>
      <br />
      마음에 드는 쪽을 선택해주세요.
      <br /><br />
      <button class="start_btn" @click="() => reset()">시작하기</button>
    </div>
    <!-- 엔딩 화면 -->
    <div v-show="showResult & !start" class="world-cup-start">
      <img src="../assets/world-cup/worldcup_end.png" alt="" />
      <br />
      <!-- 캡쳐 영역 시작 -->
      <div ref="worldcupResult" class="result">
        <br />당신의 선택<br />
        <h3>
          {{ combineword }}
        </h3>
        <br />
        당신의 유형<br />
        <a
          style="color:#ff9292; font-size: 5rem; font-weight: 800; text-shadow: 1px 1px #c83535;"
        >
          {{ resultname }}
        </a>
      </div>
      <!-- 캡쳐 영역 끝 -->
      <div class="resultdesc">{{ resultdescription }}</div>
      <br /><br />
      나의 취향을 공유하고<br />
      다른 사람의 취향도 알아봐요~<br /><br />
      <share
        url="https://spready.net/world-cup"
        title="취향으로 알아보는 심리 테스트"
        :image="image"
        v-on:click="() => capture()"
      />
      <br /><br />
      <button class="start_btn" @click="() => gohome()">HOME</button>
    </div>
    <!-- 문제 화면 -->
    <div v-if="!showResult & !start" class="world-cup-mid">
      <div class="world-cup-content-container_left">
        <img
          :src="pairs[currentStep][0].image"
          alt="image1"
          class="world-cup-image-left"
          @click="() => select(pairs[currentStep][0])"
        />
        <div class="name">{{ pairs[currentStep][0].desc }}</div>
      </div>
      <div class="world-cup-content-container_right">
        <img
          :src="pairs[currentStep][1].image"
          alt="image2"
          class="world-cup-image-right"
          @click="() => select(pairs[currentStep][1])"
        />
        <div class="name">{{ pairs[currentStep][1].desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import shuffle from "lodash.shuffle";
import Share from "./Share";

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "WorldCup",
  components: {
    Share
  },
  data() {
    return {
      showResult: false,
      start: true,
      image: null,
      currentStep: 0,
      choices: [],
      combineword: "",
      word: [],
      varE: 0,
      varI: 0,
      varS: 0,
      varN: 0,
      varT: 0,
      varF: 0,
      varJ: 0,
      varP: 0,
      mbti: "",
      resultname: "",
      resultdescription: "",
      pairs: [
        [
          {
            image: require("../assets/world-cup/1.jpg"),
            desc: "짜장면",
            name: "a"
          },
          {
            image: require("../assets/world-cup/2.jpg"),
            desc: "짬뽕",
            name: "b"
          }
        ],
        [
          {
            image: require("../assets/world-cup/3.jpg"),
            desc: "산",
            name: "c"
          },
          {
            image: require("../assets/world-cup/4.jpg"),
            desc: "바다",
            name: "d"
          }
        ],
        [
          {
            image: require("../assets/world-cup/5.jpg"),
            desc: "개",
            name: "e"
          },
          {
            image: require("../assets/world-cup/6.jpg"),
            desc: "고양이",
            name: "f"
          }
        ],
        [
          {
            image: require("../assets/world-cup/7.jpg"),
            desc: "후라이드치킨",
            name: "g"
          },
          {
            image: require("../assets/world-cup/8.jpg"),
            desc: "양념치킨",
            name: "h"
          }
        ],
        [
          {
            image: require("../assets/world-cup/11.jpg"),
            desc: "찍먹",
            name: "i"
          },
          {
            image: require("../assets/world-cup/12.jpg"),
            desc: "부먹",
            name: "j"
          }
        ],
        [
          {
            image: require("../assets/world-cup/13.jpg"),
            desc: "눈",
            name: "k"
          },
          {
            image: require("../assets/world-cup/14.jpg"),
            desc: "비",
            name: "l"
          }
        ],
        [
          {
            image: require("../assets/world-cup/17.jpg"),
            desc: "집안",
            name: "m"
          },
          {
            image: require("../assets/world-cup/18.jpg"),
            desc: "집밖",
            name: "n"
          }
        ],
        [
          {
            image: require("../assets/world-cup/19.jpg"),
            desc: "아침",
            name: "o"
          },
          {
            image: require("../assets/world-cup/20.jpg"),
            desc: "저녁",
            name: "p"
          }
        ],
        [
          {
            image: require("../assets/world-cup/21.jpg"),
            desc: "여름",
            name: "q"
          },
          {
            image: require("../assets/world-cup/22.jpg"),
            desc: "겨울",
            name: "r"
          }
        ]
      ],
      answer: [
        {
          asisname: "ESTP",
          tobename: "A",
          misc:
            "리더쉽이 있고, 손재주가 좋음, 약간은 관종, 어른들이 좋아함. 밖에 나가서 사람만나는 건 좋지만 나가기까지는 싫음. 스트레스 잘 안받고 적극적이지도 않아서 사는대로 사는 편. 모임 나가면 어느새 내가 분위기 주도하고 있음. 외로움을 많이 탐"
        },
        {
          asisname: "ESTJ",
          tobename: "B",
          misc:
            "호불호가 확실하고 리더 맡는건 싫지만 막상 하면 잘함. 나가서 노는 것 보단 이것저것 배우는 게 좋음. 남이 일처리 못하는 걸 싫어해서 차라리 내가 두세배로 일 다하는게 맘 편함. 시간 약속 어기는 거 싫고, 즉흥적인 걸 싫어함. 남에 대한 관심보다는 나에게 집중. 한 우물만 파는 스타일. 사람들이 아는 내 성격이랑 혼자 있을 때랑 다름."
        },
        {
          asisname: "ESFP",
          tobename: "C",
          misc:
            "사람의 단점보단 장점을 보고, 싸움보단 평화가 좋음. 사교성 좋아서 아무랑 잘 놀고 친구의 친구랑 같이 놀아도 노상관. 자존감이 높아서 내 위주로 돌아감. 성격이 급하고 오지랖이 넓은 편. 혼자 있을 때 지루해서 뭔가를 계속 하고 있어야 하고, 모임장소에서 침묵 흐르는게 제일 싫음."
        },
        {
          asisname: "ESFJ",
          tobename: "D",
          misc:
            "계획을 세우고, 철저하게 지키는 당신. 새로운 사람과 만나는 걸 좋아하고, 책읽고 영화보는걸 좋아함. 상담해주거나, 고민을 털어놓을 수 있는 사람. 친구, 가족, 내 주변 사람들 챙기고, 인간관계 틀어지면 스트레스 많이 받음. 어디 가면 어색한거 못참고 먼저 말 거는 스타일."
        },
        {
          asisname: "ENFP",
          tobename: "E",
          misc:
            "당신은 흥미있고 관심있는 것에 엄청 열정적이나 관심 없는 것은 1도 알고 싶어하지 않은 호불호 분명한 스타일. 낯을 좀 가리지만 풀리면 금방 친해지고 말도 많고 이야기 하는걸 좋아함. 무언가에 쉽게 몰두하지만 또 쉽게 그만둠. 무계획이고 즉흥적이며 감정기복 심함. 친구들이랑 노는게 좋지만, 내 시간 갖고 싶을 땐 철저하게 혼자 있는게 좋음. 남 이야기에 리액션을 잘 해주고, 거짓말 잘 못해서 입 발린 말 잘 못함. 감정이 얼굴에 다 드러나는 편."
        },
        {
          asisname: "ENFJ",
          tobename: "F",
          misc:
            "당신은 핵인싸. 사람들을 이끄는 타고난 기질이 있고 좋아함. 상대가 나를 신뢰한다는 느낌을 받으면 너무 좋음. 단순하고 멘탈도 강함. 사람들에게 잘 맞춰주는 성격. 일에 흥미가 많아서 꿈이 여러 개. 센스있고 눈치가 빠름. 남들 신경쓰고 잘해주려 해서 그만큼 상처도 받음."
        },
        {
          asisname: "ENTP",
          tobename: "G",
          misc:
            "당신은 이상주의자. 독립심, 자존심이 강하고 냉철한 편. 고집이 쎄고, 내 의견이 상대랑 다르면 설득하려는 스타일. 토론이나 논쟁할 때 내 의견으로 끝나야 속이 시원. 나한테 잘해주는 사람은 두배로 잘해주지만, 나한테 못하면 1도 없음. 다른 사람 일에 관심이 없고, 다른 사람이 나를 어떻게 생각하는 지도 별로 관심 없음."
        },
        {
          asisname: "ENTJ",
          tobename: "H",
          misc:
            "약간은 불도저같은 당신. 남이 이래라 저래라 하는걸 싫어하고, 일을 잘 못하는 사람과 함께하면 결국 스스로 다해야 속이 편함. 열등감은 잘 안느껴봄. 자기애가 강하고, 똑똑하지만 하기 싫은건 안함. 새로운 사람과 만나는 건 좋지만 깊은 관계 맺는 건 별로 안좋아함. 앞일을 걱정하기 보단 여러가지 가능성을 생각해보고 해결해나가는 편. 현실적이지만 상상력도 풍부함."
        },
        {
          asisname: "ISTP",
          tobename: "I",
          misc:
            "만사가 귀찮은 당신. 새로운 사람을 만나는건 싫지만, 친해지면 말도 많고 장난도 잘 치는 스타일. 내 이야기를 잘 하지 않고, 혼자 즐기는 걸 좋아함. 주류에 속하는 건 부담스럽고, 남이 자기자랑 하는 건 꼴보기 싫음. 하나에 꽂히면 끝장을 보고, 내가 맡은 일은 끝까지 하는 편. 위계질서를 싫어하고, 간섭받는 걸 싫어함."
        },
        {
          asisname: "ISFP",
          tobename: "J",
          misc:
            "당신은 조용한 관종. 귀찮고 무기력하지만, 한번 삘받으면 제대로 하는 스타일. 집에 있는 걸 좋아하고, 나가서 노는 건 좋지만 금방 지치고, 사랑들에게 기빨리는 편. 칭찬 받으면 하루종일 그 생각이 남. 갈등이나 불화를 싫어해서 거절을 잘 못하고 양보를 하는 편. 분석이나 판단력이 좋지만 막상 적극적으로 행동으로 옮기지는 못함. 겸손하다는 말을 종종 들고, 인간 관계에 신경을 많이 쓰는 편."
        },
        {
          asisname: "INFP",
          tobename: "K",
          misc:
            "당신은 게으른 완벽주의자. 잡생각이 많고, 가끔 우울한 자신에게 심취함. 개인적인 이야기를 남에게 하는걸 싫어함. 그렇지만 남이 나를 어떻게 생각하는 지에 대해서는 고민함. 너무 많은 사람보다는 한두명이랑 어울리는 게 마음이 편함. 계획적으로 잘 하지 못해서 벼락치기 하지만 똑똑해서 망치지는 않음. 남에게 폐 끼치는걸 극도로 싫어함. 혼자 있는 건 좋지만, 또 외로운 건 싫음."
        },
        {
          asisname: "INTP",
          tobename: "L",
          misc:
            "당신은 자발적인 아웃사이더. 혼자 있을 때가 제일 편하고 행복. 자기애가 강하고 공상을 자주함. 분석이나 추리를 좋아함. 잡담은 잘 못하고, 멍청한 사람을 보면 화가 남. 지식에 대한 욕심이 강하고, 진지한 스타일. 감정기복은 별로 없고, 상처도 잘 안받음. 인간관계가 계산적인 편. 시작한 건 끝을 봐야하고, 완벽하게 못할거면 안하는 편. 남에게 피해주는 걸 싫어하고 남에게 관심도 별로 없음."
        },
        {
          asisname: "INFJ",
          tobename: "M",
          misc:
            "생각이 너무 많은 당신. 새로운 일이나 새로운 사람을 만나는 건 힘든 일. 겉으로는 안그러지만 속으로는 욕도 많이 하는 편. 할 일은 미리미리 하는 편. 친해지고 싶은 사람이 먼저 다가와주길 바람. 조용한 편이지만, 가끔은 튀고 싶을 떄가 있음. 계획을 세워서 무언가 하는 걸 좋아하고, 혼자 생각할 시간이 꼭 필요. 친하고 마음 맞는 친구와 둘이 노는 걸 좋아함. 예술적이고 감수성이 풍부한 편."
        },
        {
          asisname: "INTJ",
          tobename: "N",
          misc:
            "혼자있을 때 제일 신나는 당신. 사람많고 시끄러운 장소는 싫어함. 계획을 짜고, 원리원칙대로 행동하는 편. 무신경하다는 소리를 듣지만 좋아하는 것에는 집착도 강함. 이성적이면서도 감성적. 어떤 일이나 현상에 대해 다양한 각도에서 해석하는 걸 좋아함. 성격이 이상하다고 스스로 생각하지만, 남에게 그런 소리 드는 건 싫음."
        },
        {
          asisname: "ISTJ",
          tobename: "O",
          misc:
            "철벽같은 당신. 원리원칙을 중시하고 계획에 따라 움직이는 걸 좋아함. 즉흥적으로 해야 하는 일이나, 약속을 어기는 걸 싫어함. 사람들 많은 곳에 가는 건 힘들어 하는 편. 협동하는 것보다 나 혼자 하는게 제일 빠르고 편함. 가끔 공감능력이 부족한거 같다는 소리를 들음. 여럿이 일을 함께 할 때, 이야기가 딴데로 새는 걸 싫어하고, 시작했으면 목표한 바는 꼭 이뤄야 함."
        },
        {
          asisname: "ISFJ",
          tobename: "P",
          misc:
            "때론 내향적이고 때론 외향적인 당신. 아싸들 사이에서는 인싸. 인싸들 사이에서는 아싸. 외로움을 많이 타지만, 많은 사람들이랑 있는 건 부담. 남들은 노잼이라고 생각하지만 스스로의 삶에 만족함. 배려심이 많고 공감을 잘하지만 인간관계에서 스트레스를 많이 받는 편. 무덤덤해 보이지만, 속으로 생각이 많음. 성격이 온화하고 겸손한 편. 나서는 건 싫지만 관심 받는 건 좋음."
        }
      ]
    };
  },
  methods: {
    select(item) {
      this.choices.push([item.name, item.desc]);
      this.currentStep++;
      if (this.currentStep >= this.pairs.length) {
        this.choices.sort();
        for (let index = 0; index < this.choices.length; index++) {
          /** 출력할 선택 목록 **/
          this.combineword += this.choices[index][1] + " . ";
          this.showResult = true;
          /** MBTI 산출 시작 **/
          if (index == 0) {
            /*
            a짜장 : 감각 S  -- 짜장 시키면 짬뽕 국물까지 먹겠다는 정보를 수집
            b짬뽕 : 직관 N -- 매운게 땡긴다는 육감에 의존
            */
            if (this.choices[index][0] == "a") this.varS += 1;
            else this.varN += 1;
          } else if (index == 1) {
            /*
            c산 : 감각 S, 판단 J -- 날씨나 몸상태같은 정보를 갖고 계획하에 감
            d바다 : 직관 N, 인식 P -- 삘 받아서 그냥 놀러감
            */
            if (this.choices[index][0] == "c") {
              this.varS += 1;
              this.varJ += 1;
            } else {
              this.varN += 1;
              this.varP += 1;
            }
          } else if (index == 2) {
            /*
            e개: 감정 F -- 개는 뭔가 생각없이 사교적 
            f고양이: 사고 T -- 고양이는 뭔가 계산적
            */
            if (this.choices[index][0] == "e") this.varF += 1;
            else this.varT += 1;
          } else if (index == 3) {
            /*
            g후라이드: 판단 J -- 양념 소스를 찍어먹는 가능성을 미리 계획
            h양념: 인식 P -- 상황에 맞춰서 그냥 먹음
            */
            if (this.choices[index][0] == "g") this.varJ += 1;
            else this.varP += 1;
          } else if (index == 4) {
            /*
            i찍먹 : 사고 T, 판단 J -- 논리적이고, 계획적임
            j부먹 : 감정 F, 인식 P -- 감정적이고, 상황에 맞추어 행동
            */
            if (this.choices[index][0] == "i") {
              this.varT += 1;
              this.varJ += 1;
            } else {
              this.varF += 1;
              this.varP += 1;
            }
          } else if (index == 5) {
            /*
            k눈: 감정 F -- 첫눈이라던가 눈은 뭔가 감정적 연결
            l비: 사고 T -- 구루미하고 방구석에서 논리적인 느낌
            */
            if (this.choices[index][0] == "k") this.varF += 1;
            else this.varT += 1;
          } else if (index == 6) {
            /*
            m집안: 내향 I
            n집밖: 외향 E
            */
            if (this.choices[index][0] == "m") this.varI += 1;
            else this.varE += 1;
          } else if (index == 7) {
            /*
            o아침: 내향 I, 감각 S -- 아침엔 보통 집에 있고, 정보를 수집하는 시간
            p저녁: 외향 E, 직관 N -- 저녁엔 보통 밖에 있고, 직관적으로 놀러감
            */
            if (this.choices[index][0] == "o") {
              this.varI += 1;
              this.varS += 1;
            } else {
              this.varE += 1;
              this.varN += 1;
            }
          } else if (index == 8) {
            /*
            q여름: 외향 E
            r겨울: 내향 I 
            */
            if (this.choices[index][0] == "q") this.varE += 1;
            else this.varI += 1;
          }
        }
        /** MBTI 산출 끝 **/
        if (this.varE > this.varI) this.mbti = "E";
        else this.mbti = "I";
        if (this.varS > this.varN) this.mbti += "S";
        else this.mbti += "N";
        if (this.varT > this.varF) this.mbti += "T";
        else this.mbti += "F";
        if (this.varJ > this.varP) this.mbti += "J";
        else this.mbti += "P";

        for (let index = 0; index < this.answer.length; index++) {
          /** MBTI 유형, 설명 **/
          if (this.mbti == this.answer[index].asisname) {
            this.resultname = this.answer[index].tobename;
            this.resultdescription = this.answer[index].misc;
          }
        }
      }
      return;
    },
    reset() {
      this.showResult = false;
      this.start = false;
      this.choices = [];
      this.currentStep = 0;
      this.combineword = "";
      this.varE = 0;
      this.varI = 0;
      this.varS = 0;
      this.varN = 0;
      this.varT = 0;
      this.varF = 0;
      this.varJ = 0;
      this.varP = 0;
      this.mbti = "";
      this.resultname = "";
      this.resultdescription = "";
    },
    gohome() {
      this.$router.go(-1);
    },
    async capture() {
      const gamescoreScreen = this.$refs.worldcupResult;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(gamescoreScreen, options);
      const file = dataURLtoFile(image, "worldcupresult.png");
      this.image = file;
    }
  },
  mounted() {
    this.pairs = shuffle(this.pairs);
  },
  watch: {
    showResult: {
      async handler(value) {
        if (value) {
          await this.capture();
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Gamja+Flower&display=swap");

.world-cup-container {
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  background: #ffe8e8;
  display: flex;
  justify-content: center;
  align-items: top;
  text-align: center;
  font-family: "Gamja Flower", cursive;
  font-size: 1.2rem;
}
.world-cup-start {
  width: 400px;
  height: 100%;
  padding-top: 40px;
}
.world-cup-mid {
  width: 400px;
  height: 320px;
  margin-top: 40px;
  display: flex;
}
.world-cup-content-container_left {
  height: 100%;
  width: 50%;
  overflow: hidden;
}
.world-cup-content-container_right {
  height: 100%;
  width: 50%;
  overflow: hidden;
}
.name {
  margin-top: -280px;
  font-size: 1.8rem;
  color: #ffffff;
  text-shadow: 1px 1px 2px #000000;
  font-weight: 600;
}
.world-cup-image-left {
  border-radius: 5px 0 0 5px;
}
.world-cup-image-right {
  border-radius: 0 5px 5px 0;
}
.result {
  padding: 20px 80px;
  background-color: #ffe8e8;
}
.resultdesc {
  margin: 0 10px;
  text-align: left;
}
.start_btn {
  width: 120px;
  background-color: #ff9292;
  border: none;
  color: #fff;
  padding: 12px 0;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.5 rem;
  margin: 10px;
  cursor: pointer;
  border-radius: 15px;
}
</style>
